module.exports = __webpack_public_path__ + "static/media/320x50.7d0439b9.png";